<template>
  <!-- 短期合作 -->
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="公司名称:" prop="shipmentTenantName">
             <el-input  placeholder="" v-model="searchFrom.shipmentTenantName"></el-input>
          </el-form-item>
           <el-form-item label="合作开始时间:" prop="createTime">
              <el-date-picker
                v-model="searchFrom.createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="009P003B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009P003B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="009P003B002"  v-if="btnFlg[2]">
            <el-button type="danger" @click="delDeiver">删除</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="takeGoods">导入</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="shipmentTenantName" width="200" :show-overflow-tooltip="true"  label="公司名称"></el-table-column>
        <el-table-column prop="contacts" width="150" label="联系人"></el-table-column>
       <el-table-column prop="telephone" width="150" label="联系电话"></el-table-column>
        <el-table-column prop="address" :show-overflow-tooltip="true" label="地址"></el-table-column>
        <el-table-column prop="cooperationNum" width="100" :show-overflow-tooltip="true"  label="合作次数"></el-table-column>
        <el-table-column prop="createTime" width="160" :formatter="dateFormat" label="合作开始时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { KCClist, KCCdelete } from '@/api/soc-customer'
export default {
  data () {
    return {
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        type: 1
      },
      total: 0,
      ids: [],
      tableList: [],
      loading: 'false',
      btnFlg: [],
      btnIdArr: ['009P003B000', '009P003B001', '009P003B002' ]

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/company/longTerm')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      KCClist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.id = []
        selectData.some(item => {
          this.ids.push(item.id)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          KCCdelete({ ids: this.ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        type: 1,
        createTime: null
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
</style>
